module.exports = __webpack_public_path__ + "static/media/samsungsharpsans_1.4002eb45.woff";